import { colors } from '../../Pages/Sindico/colors';
import styled from 'styled-components';

export const StyledContainerFolder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  box-sizing: border-box;

  .files {
    height: calc(100vh - 316px);
    overflow-y: auto;
    overflow-x: hidden;
    align-content: baseline;
    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
      opacity: 0.7;
      border-left: 16px solid transparent;
    }

    &::-webkit-scrollbar {
      width: 12px;
      background-color: #f5f5f5;
      opacity: 0.7;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: rgba(0, 0, 0, 0.2);
      opacity: 0.5;
      border-left: 16px solid transparent;
    }
  }

  .container-load-files-and-qnt {
    margin-top: 32px;
    display: flex;
    align-items: center;

    .qnt-files {
      font-size: 16px;
      line-height: 24px;
      color: ${colors.gray[450]};
    }

    .load-more-files {
      font-size: 16px;
      color: ${colors.primary};
      display: flex;
      align-items: start;
      gap: 16px;

      line-height: 24px;
      width: fit-content;
      height: fit-content;
      border: none;
      background-color: transparent;

      &:hover {
        cursor: pointer;
        opacity: 0.9;
      }

      &:disabled {
        cursor: pointer;
      }
    }
  }

  @media (max-width: 1024px) {
    .files {
      max-height: calc(100vh - 286px);
    }
  }
`;
